import ImageSearch from '@mui/icons-material/ImageSearch'
import { InputProps, SxProps, Theme } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import { FileWithSrc } from 'hooks/useFileInput'
import { forwardRef, useEffect, useState } from 'react'
import { colors } from 'styles/theme'

type Props = InputProps & {
  sx?: SxProps<Theme>
  initialImageSource?: string
  inputRef: React.RefObject<HTMLInputElement>
  file: FileWithSrc
}

export const IconInput = forwardRef((props: Props, _) => {
  const { sx, initialImageSource, inputRef, file, ...inputProps } = props

  const [initialPreview, setInitialPreview] = useState<string>(null)

  useEffect(() => {
    setInitialPreview(initialImageSource)
  }, [initialImageSource])

  useEffect(() => {
    if (!file) return
    // @ts-expect-error: Argument is not assignable to parameter of type ChangeEvent
    inputProps.onChange?.(file.file)
  }, [file])

  const getImage = () => {
    let source = null

    if (initialPreview) source = initialPreview
    if (inputProps.value) source = URL.createObjectURL(inputProps.value as File)
    if (file) source = file.src

    return (
      <ImagePreviewWrapper style={{ borderWidth: source ? 0 : null }}>
        {source ? (
          <ImagePreview src={source} alt="Preview" />
        ) : (
          <ImageSearch sx={{ color: colors.gray[400] }} />
        )}
      </ImagePreviewWrapper>
    )
  }

  return (
    <FormControl error={inputProps.error} sx={sx} variant="standard">
      <IconButton
        disableRipple={true}
        size="small"
        onClick={() => inputRef?.current?.click()}
        sx={{ width: 56, borderRadius: '4px' }}
      >
        {getImage()}
      </IconButton>
      <HiddenInput ref={inputRef} accept=".png, .jpg, .jpeg" type="file" />
    </FormControl>
  )
})

export default IconInput

// Styles
const HiddenInput = styled('input')`
  display: none;
`

const ImagePreviewWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border: 1px solid ${colors.gray[400]};
  border-radius: 4px;
`

const ImagePreview = styled('img')`
  max-width: 100%;
  max-height: 100%;
  border: 1px solid ${colors.gray[200]};
  border-radius: 4px;
  font-size: 10px;
`
